/** Stable error codes aligned with orya-backend where applicable. */
export enum AppErrorCode {
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  CONNECTOR_OPERATION_TIMEOUT = 'CONNECTOR_OPERATION_TIMEOUT',
  UNKNOWN = 'UNKNOWN',
  PLAN_CONFIGURATION_CONFLICT = 'PLAN_CONFIGURATION_CONFLICT',
  PLAN_UNAVAILABLE = 'PLAN_UNAVAILABLE',
  PLAN_REQUIRED = 'PLAN_REQUIRED',
  PLAN_MODULE_DISABLED = 'PLAN_MODULE_DISABLED',
  LICENSE_REDUCTION_BELOW_USAGE = 'LICENSE_REDUCTION_BELOW_USAGE',
  QUOTA_USERS_EXCEEDED = 'QUOTA_USERS_EXCEEDED',
  CONCURRENT_USERS_LIMIT_REACHED = 'CONCURRENT_USERS_LIMIT_REACHED',
  QUOTA_WHATSAPP_CONNECTIONS_EXCEEDED = 'QUOTA_WHATSAPP_CONNECTIONS_EXCEEDED',
}
